import { FormProvider, useForm } from "react-hook-form";
import DirectoryPickerInput from "@/components/shared/form/fields/DirectoryPickerInput.tsx";
import FormActions from "@/components/shared/form/fields/FormActions.tsx";
import { useMutation } from "react-query";
import { fetchApi } from "@/helpers/reactQueryApi.ts";
import { join, map } from "lodash";
import { useParams } from "@/helpers/tixxt-router.tsx";

export default function RoleAssignmentsForm() {
  const { groupSlug } = useParams();
  const methods = useForm<{ memberships: { id: string }[] }>();
  const { handleSubmit } = methods;

  const endpoint = groupSlug
    ? `/groups/${groupSlug}/administration/role_assignments`
    : "/administration/role_assignments";

  const { mutate: assignRoles } = useMutation<unknown, unknown, FormData>(
    (body) =>
      fetchApi(endpoint, {
        method: "POST",
        body,
      }),
    { onSuccess: () => location.reload() },
  );

  function submit({ memberships }: { memberships: { id: string }[] }) {
    const csvIds = join(map(memberships, "id"), ",");

    const body = new FormData();
    body.append("role_assignment[memberships][csv]", csvIds);

    assignRoles(body);
  }

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2.5" onSubmit={handleSubmit(submit)}>
        <DirectoryPickerInput
          name="memberships"
          endpoint="/directory/members"
          multi
        />
        <FormActions
          saveText={I18n.t("administration.role_assignments.index.save")}
          showCancel={false}
        />
      </form>
    </FormProvider>
  );
}
